import Controller from "@sabyr-dev/mist_core/controller";
import { InitializeEvent } from "@sabyr-dev/mist_core/events";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyApp } from "../app";

export class InitController extends Controller<Product, Attempt, Quiz, Question> {
	bind(target: EventTarget, app: AcademyApp): void {
		target.addEventListener(InitializeEvent.type, () => this.initialize(app));
	}

	initialize(app: AcademyApp): void {
		const bindTarget = app.view.getBindTarget();
		[
			app.view.settings.getBindSaveEmail(),
			app.view.settings.getBindRetryEmail(),
			app.view.settings.getBindPartialResults(),
			app.view.settings.getBindCheckEmail()
		].map(bind => bind.bind(bindTarget));
		if (typeof app.config.freeQuestions == 'number') {
			app.view.list.displayLockedQuestions(app.config.freeQuestions, !app.config.hasEmail, app.config.color);
		}
	}
}
